(()=>{
'use strict';

if(window.fbInboxCartBridgeBoot)return;
window.fbInboxCartBridgeBoot=1;

const ROOT=window.Shopify?.routes?.root||'/';
let lastConfirmKey='';
let lastConfirmAt=0;

function currentScriptUrl(){
  const s=document.currentScript||[...document.scripts].find(x=>/\/custom\.js(?:\?|$)/.test(x.src||''));
  return s?.src||'';
}

function loadAdvancePaymentCss(){
  if(document.querySelector('[data-fb-apc-style]'))return;
  const src=currentScriptUrl();
  if(!src)return;
  try{
    const u=new URL(src,location.href);
    u.pathname=u.pathname.replace(/\/custom\.js$/,'/fb-advance-payment.css');
    u.search='';
    const l=document.createElement('link');
    l.rel='stylesheet';
    l.href=u.toString();
    l.dataset.fbApcStyle='';
    document.head.appendChild(l);
  }catch{}
}

function loadOriginalCustom(){
  if(window.fbApc)return;
  const src=currentScriptUrl();
  if(!src)return;
  try{
    const u=new URL(src,location.href);
    u.pathname=u.pathname.replace(/\/custom\.js$/,'/custom.fb-pre-inbox-bridge.js');
    u.search='';
    const s=document.createElement('script');
    s.src=u.toString();
    s.async=false;
    s.dataset.fbOriginalCustom='';
    document.head.appendChild(s);
  }catch{}
}

function showToast(message,key){
  const now=Date.now();
  if(key&&key===lastConfirmKey&&now-lastConfirmAt<2500)return;
  lastConfirmKey=key||message;
  lastConfirmAt=now;

  let box=document.getElementById('fb-ai-cart-confirmation');
  if(!box){
    box=document.createElement('div');
    box.id='fb-ai-cart-confirmation';
    box.setAttribute('role','status');
    box.setAttribute('aria-live','polite');
    box.setAttribute('aria-atomic','true');
    box.innerHTML='<strong>Falcon AI</strong><span data-fb-ai-cart-message></span><a href="'+ROOT+'cart">Review cart</a>';
    Object.assign(box.style,{
      position:'fixed',top:'16px',right:'16px',zIndex:'2147483600',display:'grid',gridTemplateColumns:'auto 1fr auto',alignItems:'center',gap:'10px 12px',
      maxWidth:'min(560px,calc(100vw - 32px))',padding:'13px 16px',borderRadius:'12px',background:'#111',color:'#fff',
      boxShadow:'0 10px 32px rgba(0,0,0,.24)',font:'inherit',fontSize:'14px',lineHeight:'1.4',opacity:'0',transform:'translateY(-8px)',
      transition:'opacity .18s ease,transform .18s ease'
    });
    const a=box.querySelector('a');
    if(a)Object.assign(a.style,{color:'#fff',fontWeight:'600',textDecoration:'underline',whiteSpace:'nowrap'});
    document.body.appendChild(box);
  }
  const text=box.querySelector('[data-fb-ai-cart-message]');
  if(text)text.textContent=message;
  clearTimeout(box._fbHideTimer);
  box.hidden=false;
  requestAnimationFrame(()=>{box.style.opacity='1';box.style.transform='translateY(0)';});
  box._fbHideTimer=setTimeout(()=>{
    box.style.opacity='0';box.style.transform='translateY(-8px)';
    setTimeout(()=>{box.hidden=true;},220);
  },5000);
}

async function ajaxCart(){
  const r=await fetch(ROOT+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
  if(!r.ok)throw new Error('Unable to read cart');
  return r.json();
}

function rawVariantId(value){
  const s=String(value||'');
  const m=s.match(/ProductVariant\/(\d+)/);
  return m?m[1]:s;
}

function buildMessage(event,cart){
  const line=event?.lines?.[0]||{};
  const wanted=rawVariantId(line.merchandiseId);
  const item=(cart?.items||[]).find(i=>String(i.variant_id||i.id)===wanted);
  if(!item)return 'Ji, item cart mein add ho gaya ✓';
  const title=String(item.product_title||item.title||'Item').trim();
  const variant=String(item.variant_title||'').trim();
  const variantPart=variant&&variant.toLowerCase()!=='default title'?' — '+variant:'';
  const qty=Number(line.quantity)||1;
  return `Ji, ${title}${variantPart}, Qty ${qty} cart mein add ho gaya ✓`;
}

function emitConfirmation(message,event,cart){
  const detail={message,action:event?.action||'add',context:event?.context||'standard-action',lines:event?.lines||[],cart:cart||null};
  try{document.dispatchEvent(new CustomEvent('fb:ai-cart-confirmed',{detail}));}catch{}
  try{window.dispatchEvent(new CustomEvent('fb:ai-cart-confirmed',{detail}));}catch{}
}

function emitFailure(message,event){
  const detail={message,action:event?.action||'add',context:event?.context||'standard-action',lines:event?.lines||[]};
  try{document.dispatchEvent(new CustomEvent('fb:ai-cart-error',{detail}));}catch{}
  try{window.dispatchEvent(new CustomEvent('fb:ai-cart-error',{detail}));}catch{}
}

async function refreshFocalCart(){
  const cart=await ajaxCart();
  window.__fbAgentAjaxCart=cart;
  try{document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart,source:'fb-ai-inbox-cart-bridge'}}));}catch{}
  return cart;
}

function configureStandardAction(){
  const action=window.Shopify?.actions?.updateCart;
  if(!action?.configure)return false;
  try{
    const ok=action.configure({
      eventTarget:()=>document,
      async handler(defaultHandler){
        const result=await defaultHandler();
        if(!result?.userErrors?.length){
          try{await refreshFocalCart();}catch{}
        }
        return {...result,detail:{...(result?.detail||{}),handledBy:'fb-ai-inbox-cart-bridge'}};
      }
    });
    window.fbInboxCartBridgeConfigured=ok!==false;
    return true;
  }catch{
    return false;
  }
}

document.addEventListener('shopify:cart:lines-update',event=>{
  if(event?.action!=='add')return;
  const context=String(event?.context||'');
  if(context&&context!=='standard-action'&&context!=='dialog')return;
  const p=event?.promise;
  if(!p||typeof p.then!=='function')return;

  p.then(async result=>{
    const errors=result?.userErrors||[];
    if(errors.length){
      const message=errors[0]?.message||'We could not add that item to your cart.';
      showToast(message,'fb-ai-cart-error:'+message);
      emitFailure(message,event);
      return;
    }

    let cart=window.__fbAgentAjaxCart||null;
    if(!cart){try{cart=await refreshFocalCart();}catch{}}
    const message=buildMessage(event,cart);
    const key='fb-ai-cart-ok:'+(event.lines||[]).map(x=>String(x.merchandiseId||x.id||'')+':'+String(x.quantity||'')).join('|');
    showToast(message,key);
    emitConfirmation(message,event,cart);
  }).catch(err=>{
    const message=err?.message||'We could not update your cart. Please try again.';
    showToast(message,'fb-ai-cart-reject:'+message);
    emitFailure(message,event);
  });
},true);

function boot(){
  if(configureStandardAction())return;
  let tries=0;
  const timer=setInterval(()=>{
    tries+=1;
    if(configureStandardAction()||tries>=80)clearInterval(timer);
  },50);
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
loadAdvancePaymentCss();
loadOriginalCustom();

})();